import * as stylex from '@stylexjs/stylex';
import { colors } from '@seeqdev/qomponents/colors.stylex';

export const formulaTableStyles = stylex.create({
  table: { width: '100%', marginBottom: 0, color: colors.bodyText },
  row: { borderTopWidth: 1 },
  selectionHeader: { backgroundColor: colors.tableRowAlternate },
  unselected: { backgroundColor: colors.formulaUnselectedBackground },
  badgeLine: { display: 'flex', flexDirection: 'row', flexWrap: 'wrap', alignItems: 'center', gap: '0.25rem' },
  badgeSummary: {
    marginTop: '0.25rem',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: '0.25rem',
  },
  badgeToggle: {
    display: 'flex',
    cursor: 'pointer',
    flexDirection: 'row',
    alignItems: 'baseline',
    gap: '0.3125rem',
    borderRadius: '0.25rem',
    borderWidth: 0,
    backgroundColor: 'transparent',
    padding: 0,
    textAlign: 'left',
    fontStyle: 'italic',
    outlineWidth: { 'default': null, ':focus-visible': 2 },
    outlineOffset: { 'default': null, ':focus-visible': 2 },
  },
  cell: { padding: 0, borderWidth: 0, verticalAlign: 'top' },
  checkboxCell: { padding: '5px' },
  selectionLabel: { position: 'relative', paddingTop: '5px', paddingBottom: '5px' },
  selectAllLabel: { cursor: 'pointer', fontWeight: 700 },
  rowHeading: { display: 'flex', flexDirection: 'row', alignItems: 'center', gap: '0.5rem' },
  nameColumn: { display: 'flex', minWidth: 0, flex: '1 1 0%', flexDirection: 'column' },
  nameLabel: { fontWeight: 700 },
  newBadge: { marginLeft: '7px', fontWeight: 700 },
  editableName: { display: 'flex', flexDirection: 'row', alignItems: 'center', gap: '0.25rem' },
  rowActions: { display: 'flex', flexDirection: 'row', alignItems: 'center' },
  actionIcon: { marginLeft: '8px' },
  mappingCheckbox: { marginTop: '0.625rem', marginBottom: '0.5rem' },
  mappingControl: { marginBottom: '0.5rem' },
  mappingLabel: { display: 'flex', flexDirection: 'row', marginBottom: '0.3125rem', alignItems: 'center' },
  mappingLabelText: { marginRight: '0.3125rem' },
  mappingHelp: { cursor: 'default' },
  parameterLabel: { marginTop: '5px', fontWeight: 700 },
  firstFormula: { marginTop: '5px' },
  formulaAlternative: { marginBottom: '12px' },
  rowContent: { position: 'relative', paddingTop: '5px', paddingBottom: '5px', paddingRight: '10px' },
  unselectableContent: { paddingLeft: '10px' },
  inlineName: { display: 'inline-block' },
});
